var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurtlePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65156 7.34375L10.4691 10H6.63281L7.24594 7.34375H9.65156Z",
    fill: "#7F43FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 6.40625L5.78125 4.39125C6.56375 3.96 7.46812 3.75 8.43687 3.75C9.38687 3.75 10.2925 3.965 11.0806 4.4075L9.74812 6.40625H7.125Z",
    fill: "#7F43FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5156 6.94977L11.8506 4.94727C12.9463 5.89914 13.6806 7.44227 13.7413 9.67727C13.7463 9.85227 13.6013 9.99977 13.4263 9.99977H11.4544L10.5156 6.94977Z",
    fill: "#7F43FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13294 9.67703C3.19544 7.42578 3.91544 5.87641 5.01606 4.92578L6.37669 6.96641L5.67606 9.99953H3.44856C3.27294 9.99953 3.12794 9.85203 3.13294 9.67703Z",
    fill: "#7F43FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7528 11.25C18.7528 10.335 18.4159 8.75 16.8778 8.75C15.1259 8.75 14.6015 9.82437 14.4447 10.4675C14.3765 10.7456 14.1265 10.9375 13.8403 10.9375H3.75279C2.17029 10.9375 1.47779 12.4956 1.30092 13.3575C1.26842 13.515 1.43842 13.6369 1.57904 13.5581C2.58717 12.995 3.30842 12.9019 4.03779 13.75L3.78967 14.7438C3.59842 15.5087 4.17717 16.25 4.96592 16.25C5.52217 16.25 6.00717 15.8725 6.14217 15.3325C6.32029 14.6194 6.53779 13.75 6.53779 13.75H10.9128L11.3084 15.3313C11.4434 15.8713 11.9284 16.25 12.4847 16.25C13.2734 16.25 13.8522 15.5088 13.6609 14.7431L13.4128 13.75C13.4128 13.75 18.7528 13.7494 18.7528 11.25ZM16.8778 11.25C16.5328 11.25 16.2528 10.97 16.2528 10.625C16.2528 10.28 16.5328 10 16.8778 10C17.2228 10 17.5028 10.28 17.5028 10.625C17.5028 10.97 17.2228 11.25 16.8778 11.25Z",
    fill: "#7F43FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurtlePurple);
export default __webpack_public_path__ + "static/media/turtle-purple.d550bf4e788d7da97787f696d160e1f4.svg";
export { ForwardRef as ReactComponent };